

import api from '../api';



const getTable = async (storeCode) => {
  const requestData = {
    "storeCode": storeCode
  }
  try {

    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/store/getTables", requestData);

    return response.data;

  } catch (error) {
    
    console.error(error)
    return error;
  }
}; // Removed requestData from dependencies


export default getTable;
